// * ========================================================================
// * machine search
// * ========================================================================

'use strict';

import $ from 'jquery';
const Mustache = require('mustache');

let filterMachines = (function() {

  let request = (data = {}, type = 'GET') => {
    let handler = $('body').data('cm-handler');

    if (handler) {
      return new Promise((resolve) => {
        $.ajax({
          url: handler,
          data,
          type,
          cache: false
        }).done((res) => {
          resolve(res);
        });
      });
    }
  };

  let _getCartItems = () => {
    return request({ action: 'loadCart' });
  };

  let _updateCartItem = ($input) => {
    if ($input && $input.val()) {
      let action = $input.prop('checked') ? 'add' : 'remove';
      let urls = [];
      let basket = 'default-basket';

      urls.push($input.val());

      request({ action, urls, basket }, 'POST');
    }
  };

  function init(){
    if($('.products').length){
      $('.js-content-search-text').on('keyup',function(){
        let searchTerm = $(this).val();
        $.ajax({
          'data': 'search='+searchTerm+'&stage-language='+$('body').data('language'),
          'url': '/stage-ajax/machine-search',
          'success': function(data){
            let template = $('#product-list').html();
            let result = '';
            result += Mustache.render(template, {items: data.machinesList, heading: data.machinesHeading});
            if(data.lowImportanceMachinesList.length){
              result += Mustache.render(template, {items: data.lowImportanceMachinesList, heading: data.lowImportanceMachinesHeading, isLowImportance: true});
            }
            result += Mustache.render(template, {items: data.accessoriesList, heading: data.accessoriesHeading});

            // Render search results
            $('.layout__main').empty().append(result);

            let $checkBoxElement = $('.js-collection-maker__checkbox-cart-toggle');

            // Set items as checked if in cart
            _getCartItems().then((cart) => {
              $.each($checkBoxElement, (i, input) => {
                let $input = $(input);
                let id = $input.val();

                if($.inArray(id, cart) !== -1){
                  $input.prop('checked', true);
                }
              });
            });

            //Update cart when state changes
            $checkBoxElement.on('change', function() {
              _updateCartItem($(this));
            });
          }
        });

      });
    }
  }

  return {
    init: init
  }
})();

module.exports = filterMachines;
